import Header from '../../Header';

class EmbeddedHeader extends Header {
  protected override copyLinkDisabled = true;
}

export default EmbeddedHeader;
